import { combineReducers } from "redux";
import allCourseReducers from "./allCourseReducers";
import allModulesReducers from "./allModulesReducers";
import viewModuleReducer from "./viewModuleReducer";
import addCourseReducers from "./addCourseReducers";
import deleteCourseReducer from "./deleteCourseReducer";
import addModuleReducer from "./addModuleReducer";
import deleteModuleReducer from "./deleteModuleReducer";
import updateModuleReducer from "./updateModuleReducer";
import updateCourseReducer from "./updateCourseReducer";

export default combineReducers({
  allCourses: allCourseReducers,
  allModules: allModulesReducers,
  singleModule: viewModuleReducer,
  newCourse: addCourseReducers,
  deletedCourse: deleteCourseReducer,
  addModule: addModuleReducer,
  deleteModule: deleteModuleReducer,
  updateModule: updateModuleReducer,
  updateCourse: updateCourseReducer,
});
